import React from 'react';
import { useSelector } from 'react-redux';
import {
  BlockTrackable,
  findValueById,
  Ribbon,
  toMoney,
  ProduktStern,
  trEnv,
  ProduktvergleichBeitragHeadline,
} from 'ion-lib';
import { Card } from 'react-bootstrap';
import Sticky from 'react-sticky-el';
import { istHausrat } from '../../helper';

const ProduktHeader = ({
  baustein = {},
  height = 0,
}) => {
  const sterne = (id) => !trEnv.istOESA && <ProduktStern anzahl={id} />;
  const zahlweise = useSelector((state) => state.daten.zahlweise);
  const empfehlungBaustein = useSelector((state) => state.daten.empfehlungBaustein);

  return (
    <Sticky
      hideOnBoundaryHit={false}
      boundaryElement={`.card--${baustein.bezeichnung.value}`}
    >
      <Card.Header className="pb-0 border-bottom-0">
        <div className="d-none d-lg-block">
          {
            sterne(parseInt(baustein.id.value, 10))
          }
          {(baustein && parseInt(baustein.id.value, 10) === empfehlungBaustein.value) && (
            <BlockTrackable trackingName="empfehlung-icon">
              <Ribbon>
                Empfehlung
              </Ribbon>
            </BlockTrackable>
          )}
        </div>
        <ProduktvergleichBeitragHeadline style={{ minHeight: height }}>
          {baustein.label.value}
          <br />
          <span className="text-nowrap">
            {istHausrat() ? toMoney(baustein.bruttoBeitrag.value) : toMoney(baustein.bruttoBeitragGlas.value)}
          </span>
          {' '}
          <small>
            {findValueById(zahlweise.valueSet, zahlweise.value)}
          </small>
        </ProduktvergleichBeitragHeadline>
        <hr className="hr--light-gray mt-2 mb-0" />
      </Card.Header>
    </Sticky>
  );
};

export default ProduktHeader;
